import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportPointStatusPageRoutingModule } from './report-point-status-routing.module';

import { ReportPointStatusPage } from './report-point-status.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportPointStatusPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [ReportPointStatusPage]
})
export class ReportPointStatusPageModule {}
